export default __webpack_public_path__ + "static/media/play-store.0cde2f26.svg";